import styled from 'styled-components';
import { colors, dimensions, typography } from '../../styles';

const inputPadding = '0px';
const inputHeight = '16px';
const inputScale = '10px';
const inputBorderWidth = '1px';
const textInputHeight = '34px';

export const TimePickerStyle = styled.div`
  display: flex;
  align-items:center;
  margin-right: 10px;

 .time-field {
    display: block;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
    width: 100% !important;
    outline: none;
    height: 51px;
    padding: 0 20px;
    border-radius: 10px;
    box-shadow: 0px 3px 20px rgb(0 0 0 / 10%);
    color: #010101;
    font-size: 12px;
    outline: 0;
    border: 1px solid #f2f2f2;
    position: relative;
  }

  > span{
    position: absolute;
    right: 20px;
    color: #D9D9D9;
  }
`


const Label = styled.label`
  // text-transform: uppercase;
  text-transform: capitalize;
  display: inline-block;
  font-weight: ${typography.fontWeightMedium};
  color: ${colors.textSecondary};
  font-size: ${typography.fontSizeUppercase}px;
  margin-bottom: 5px;
  min-width: 40px;

  // margin-right: 10px;
  // position: absolute;
  // left: 10px;
  // top: -10px;
  // color: #95959d;
  // padding: 0px 8px 0px 8px;
  // background: #ffffff;

  span {
    color: ${colors.colorCoreRed};
  }
`;

export const SmallLabel = styled.label`
  color: #2B3C93;
  leading-trim: both;
  text-edge: cap;
  font-size: 18px;
  font-style: normal;
  font-weight: 800;
  letter-spacing: 1.6px;
  text-transform: uppercase;
`

const ControlLabels = styled.div`
  line-height: 49px;
  font-size: 36px;
  font-weight: 700;
  margin: 0;
    height: auto;
  text-transform: uppercase;
  display: inline-flex;
  // font-weight: ${typography.fontWeightBold};
  color:#2B3C93;
  // font-size: ${typography.fontSizeHeading8}px;
  letter-spacing: 0.1em;
  @media (max-width: 767px) {
    font-size: 22px !important;
  }
`;

//browser default form invalid styling
const formInvalid = `
  &.form-invalid {
    border-bottom: 1px solid ${colors.colorCoreRed};
  }
`;

const Formgroup = styled.div`
  margin-bottom: 30px;
  position: relative;

  &::before {
    position: absolute;
    content: '';
    left: 10px;
    height: 21px;
    top: -10px;
  }

  label {
    text-align: left;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #010101;
    display: block;
  }

  p {
    font-size: 12px;
    color: ${colors.colorCoreGray};
    margin: 0;
  }

  .Select-control {
    border-radius: 10px;
    box-shadow: 0px 3px 20px rgb(0 0 0 / 10%);
    color: #010101;
    font-size: 12px;
    outline: 0;
    border: 1px solid #f2f2f2;
    width: 100%;
    outline: none;
    padding: 8px 12px;
    position: initial;

    &:hover {
      border: 1px solid ${colors.colorLightGray};
    }

    &:focus {
      outline: none;
      border: 1px solid ${colors.themeBlack};
    }
  }

  .Select-placeholder, .Select--single > .Select-control .Select-value {
    height: 100%;
    display: flex;
    align-items: center;
    padding-left: 20px;
  }

  input[type='color'] {
    background: ${colors.colorWhite};
    padding: 12px;
  }
`;

const Input = styled.input`
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ::placeholder {
    color: #bababa;
  }
  ${formInvalid} display: block;
  border: none;
  // width: 100%;
  // height: ${textInputHeight};
  // padding: ${dimensions.unitSpacing}px;
  // color: ${colors.textPrimary};
  // border-bottom: 1px solid ${colors.colorShadowGray};
  // background: none;
  transition: all 0.3s ease;
  // background: #FAF8FF;
  //   border: 0.800000011920929px solid #DAE0E6;
  //   border-radius: 5px;
   // border: 1px solid #e0e3ff;
    width: 100%;
    outline: none;
    height: 51px;
    padding: 0 20px;
    border-radius: 10px;
    box-shadow: 0px 3px 20px rgb(0 0 0 / 10%);
    color: #010101;
    font-size: 14px;
    line-height: 19px;
    outline: 0;
    border: 1px solid #fff0;

  ${(props) => {
    if (props.round) {
      return `
        font-size: 13px;
        border: 1px solid ${colors.borderDarker};
        border-radius: 20px;
        padding: 5px 20px;
      `;
    }
  }};

  ${(props) => {
    if (props.disabled) {
      return `
        color: #999797;
        cursor: not-allowed !important;
      `;
    }
  }};

  &:hover {
    border: 1px solid ${colors.colorLightGray};
    // border-color: ${colors.colorLightGray};
  }

  &:focus {
    outline: none;
    border: 1px solid ${colors.themeBlack};
    // border-color: ${colors.themeBlack};
  }
`;
const FileInput = styled.input`
  ${formInvalid} display: block;
  border: none;
  width: 100%;
  height: ${textInputHeight};
  padding: ${dimensions.unitSpacing}px;
  color: ${colors.textPrimary};

  ${props => {
    if (props.round) {
      return `
        font-size: 13px;
        padding: 5px 20px;
      `;
    }
  }};
`;

const SelectWrapper = styled.div`
  ${formInvalid} overflow: hidden;
  // border-bottom: 1px solid ${colors.colorShadowGray};
  // width: 100%;
  // height: ${textInputHeight};
  // position: initial;

  &:after {
    position: absolute;
    right: 10px;
    top: 22px;
    content: '\\e827';
    font-size: 10px;
    display: inline-block;
    font-family: 'erxes';
    speak: none;
    color: ${colors.colorCoreGray};
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    text-rendering: auto;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
  }
`;

const Select = Input.withComponent('select').extend`
  ${formInvalid}

  border: none;
  height: ${textInputHeight};
  padding: 0 ${dimensions.unitSpacing}px;
  width: calc(100% + ${dimensions.coreSpacing}px);
  -webkit-appearance: none;

  border: 1px solid #e0e3ff;
    width: 100%;
    outline: none;
    // height: 51px;
    padding: 8px 12px;
    border-radius: 4px;

    &:hover {
      border: 1px solid ${colors.colorLightGray};
    }

    &:focus {
      outline: none;
      border: 1px solid ${colors.themeBlack};
    }
`;

const TextArea = Input.withComponent('textarea').extend`
  ${formInvalid}
  transition: none;
  max-height: ${props => props.maxHeight && `${props.maxHeight}px`};
  min-height: 80px;
`;

const FormLabel = styled.label`
  position: relative;
  display: inline-block;
  font-weight: normal;

  span {
    cursor: pointer;
    display: inline-block;
  }
`;

const inputStyle = styled.input`
  ${formInvalid} border: 0 !important;
  clip: rect(1px, 1px, 1px, 1px) !important;
  clip-path: inset(50%) !important;
  height: 1px !important;
  overflow: hidden !important;
  padding: 0 !important;
  position: absolute !important;
  width: 1px !important;
  white-space: nowrap !important;

  &:focus {
    + span {
      &::before {
        box-shadow: 0 0 0 2px rgba(#333, 0.4) !important;
      }
    }
  }

  &:hover {
    + span {
      &::before {
        border-color: ${colors.colorLightGray};
      }
    }
  }

  &:active {
    + span {
      &::before {
        transition-duration: 0;
      }
    }
  }

  + span {
    position: relative;
    padding: ${inputPadding};
    user-select: none;

    &:before {
      background-color: ${colors.colorWhite};
      border: ${inputBorderWidth} solid ${colors.colorShadowGray};
      box-sizing: content-box;
      content: '';
      color: ${colors.colorWhite};
      margin-right: calc(${inputHeight} * 0.25);
      top: 51%;
      left: 0;
      width: ${inputHeight};
      height: ${inputHeight};
      display: inline-block;
      vertical-align: top;
    }

    &:after {
      box-sizing: content-box;
      content: '';
      background-color: ${colors.colorWhite};
      position: absolute;
      top: 43%;
      left: calc(${inputPadding} + ${inputBorderWidth} + ${inputScale} / 2);
      width: calc(${inputHeight} - ${inputScale});
      height: calc(${inputHeight} - ${inputScale});
      margin-top: calc((${inputHeight} - ${inputScale}) / -2);
      transform: scale(0);
      transform-origin: 51%;
      transition: transform 200ms ease-out;
    }
  }

  + span:last-child:before {
    margin-right: 0px;
  }
`;

const Radio = inputStyle.extend`
  + span {

    &::before,
    &::after {
      border-radius: 50%;
    }
  }

  &:checked {

    &:active,
    &:focus {

      + span {

        &::before {
          animation: none;
          filter: none;
          transition: none;
        }
      }
    }

    + span {

      &:before {
        animation: none;
        background-color: ${colors.themeBlue};
        border-color: transparent;
      }

      &:after {
        transform: scale(1);
      }
    }
  }
`;

const Checkbox = inputStyle.extend`
  + span {
    &:after {
      background-color: transparent;
      top: 45%;
      left: calc(1px + ${inputHeight}/5);
      width: calc(${inputHeight}/2);
      height: calc(${inputHeight}/5);
      margin-top: c alc(${inputHeight} / -2 / 2 * 0.8);
      border-style: solid;
      border-color: ${colors.colorWhite};
      border-width: 0 0 2px 2px;
      border-radius: 0;
      border-image: none;
      transform: rotate(-45deg) scale(0);
      transition: none;
    }

    &:before {
      animation: none;
      // background-color: ${colors.themeBlue};
      // border-color: transparent;
      background: #FFFFFF;
      border: 1px solid #28A6DE;
      border-radius: 5px;
    }
  }

  &:checked + span {

    &:before {
      animation: none;
      // background-color: ${colors.themeBlue};
      // border-color: transparent;
      background: #28A6DE;
    }

    &:after {
      content: '';
      transform: rotate(-45deg) scale(1);
      transition: transform 200ms ease-out;
    }
  }
`;

const SeachForm = styled.div`
  position: relative;
  margin: auto;
  display: flex;
  align-items: center;

  input[type='text'] {
    line-height: 19px;
    height: 40px;
    padding-left: 20px;
    padding-right: 40px;
    font-size: 14px;
    background: #FFFFFF;
    box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    border:0px;
    width: 350px;
  }
  @media (max-width: 576px){
    input[type='text'] {
      width: 210px;
    }
  }
  @media (min-width: 800px) and (max-width: 920px){
    input[type='text'] {
      width: 210px;
    }
  }
  span {
    position: absolute;
    right: 13px;
    color: #D9D9D9;
    font-size: 18px;
    cursor: pointer;
  }
  input[type='text']::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #B1B1B1;
    opacity: 1; /* Firefox */
  }

  input[type='text']:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #B1B1B1;
  }

  input[type='text']::-ms-input-placeholder { /* Microsoft Edge */
    color: #B1B1B1;
  }
`;

const SoundGroup = styled.div`
  // height: 211px;
  padding: 70px 0px 70px 0px;
  width: 100%;
  margin: 15px 0 auto;
  position: relative;
  text-align: center;
  // line-height: 195px;
  border: 1px dashed #dae0e6;
  display: inline-block;
  transition: transform 0.3s;
  background: #faf8ff;
  letter-spacing: 0.23px;
  color: #5b5b5b;
  border-radius: 14px;
  img {
    display: block;
    width: 40px !important;
    height: 40px !important;
    // margin: 50px auto -57px auto;
    border-radius: 0px;
    margin: auto;
  }
  input[type='file'] {
    position: absolute;
    height: 100%;
    width: 100%;
    opacity: 0;
    top: 0;
    left: 0;
    cursor: pointer;
  }
`;

const UserProfile = styled.div`
  text-align: center;
  input[type='file'] {
    position: absolute;
    height: 100%;
    width: 100%;
    opacity: 0;
    top: 0px;
    left: 0;
    cursor: pointer;
  }
  img {
    display: block;
    // width: 40px !important;
    // height: 40px !important;
    // margin: 50px auto -57px auto;
    border-radius: 50px;
    margin: auto;
  }
`;

export {
  Input,
  SelectWrapper,
  Select,
  TextArea,
  Radio,
  Checkbox,
  FormLabel,
  Label,
  Formgroup,
  FileInput,
  SoundGroup,
  UserProfile,
  ControlLabels,
  SeachForm
};



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/form/styles.js